const BackgroundGrid = () => {
    return (
        <div className="full-width">
            <div className="grid-linear"></div>
            <div className="grid-linear"></div>
            <div className="grid-linear"></div>
            <div className="grid-linear"></div>
        </div>
    )
}

export default BackgroundGrid;